var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","plain":""},on:{"click":_vm.handleExport}},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_vm._v(_vm._s(_vm.btnName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }